import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { megaLogo } from '../../api';

const SidebarIcon = () => {
  return (
    <div className="logo-icon-wrapper">
      <Link to={`${process.env.PUBLIC_URL}/${localStorage.getItem('homePage')}`}>
        <img
          className="img-fluid"
          src={megaLogo}
          alt=""
          style={{width: "40px"}}
        />
      </Link>
    </div>
  );
};

export default SidebarIcon;